<template lang="pug">
  section(id="boxes")
     .goscontainer
          .heading Наши программные решения
          v-row(no-gutters)
            v-col( v-for="(feature, i) in features"
                   :key="i"
                   cols="12"
                   :md="i>0? 2:4")
          
              div.box.d-flex.align-center.flex-column.mr-3
                v-img(:src="require(`@/assets/img/home/${feature.icon}.svg`)" max-width="143" max-height="143")
              
                div.title(v-html="feature.title")
                div.text(v-html="feature.text")
                div.link 
                v-btn.mt-auto.btn( width="100%" dark large depressed :to="'/page/box/'+feature.link") ПОДРОБНЕЕ

            
</template>

<script>
  export default {
    name: 'SectionBoxes',
    data: () => ({
      features: [
        {
          title: 'Платформа<br> СУДЕБНЫЙ ПОРТАЛ',
          text: 'Модульная многопользовательская платформа для аппарата суда и участников судопроизводства<br> Создано с учетом потребностей профессионального сообщества',
          icon: 'SP',
          link: 'platform',
        },
        {
          title: 'Удаленное судебное заседание',
          text: 'Сервис для организации и проведения судебных заседаний с участием сторон по удаленной связи (аудио и видео-трансляции) с использованием сети интернет.',
          icon: 'USZ',
          link: 'usz',
        },
        {
          title: 'Заказ судебных документов',
          text: 'Сервис для заказа и получения документов в канцелярии суда всеми участниками судебного процесса.',
          icon: 'ZSD',
          link: 'zsd',
        },
        {
          title: 'Заявки<br> адвоката',
          text: 'Модуль для приема и обработки заявок по оплате процессуальных издержек для экспертов, переводчиков и адвокатов',
          icon: 'ZA',
          link: 'za',
        },
        {
          title: 'ФСИН',
          text: 'Модуль электронной логистики расписок, конвоирок между структурами судебно-исполнительной системы',
          icon: 'FSIN',
          link: 'fsin',
        },
      ],
    }),
  }
</script>

<style lang="sass" scoped>
  #boxes
    padding: 48px 16px 72px 16px 
    background-color: #FFFFFF
    color: #000000
    .heading 
        font-weight: 500
        font-size: 40px
        margin-bottom: 48px
        color:#000000
        text-align: center
    .title
        margin-top: 38px
        text-align: center
        font-size: 24px
        font-weight: 700
        line-height: 32px
        min-height: 120px
    .text
        margin-bottom:24px
        text-align: center
        font-size: 14px
        font-weight: 400
        line-height: 16px
    .box
        padding: 50px 16px 32px 16px
        box-shadow: 0 .2rem 1rem rgba(0, 0 , 0, .15)
        height:100%
    .btn
        background-color: #0E9DBC
        border-radius: 0
    .btn:hover
        background-color: #ED0E51

  @media (max-width: 960px) 
    #boxes
      .text
          font-size: 20px
</style>
